import {
    CheckCircleRounded,
    CircleRounded,
    ColorizeRounded,
} from '@mui/icons-material';
import {
    Card,
    Checkbox,
    ClickAwayListener,
    Divider,
    IconButton,
    Popover,
    Popper,
    Stack,
} from '@mui/material';
import { useRef } from 'react';

const colors = [
    [
        '#000000',
        '#434343',
        '#666666',
        '#999999',
        '#B7B7B7',
        '#CCCCCC',
        '#D9D9D9',
        '#EFEFEF',
        '#F3F3F3',
        '#FFFFFF',
    ],
    [
        '#980000',
        '#FF0000',
        '#FF9900',
        '#FFFF00',
        '#00FF00',
        '#00FFFF',
        '#4A86E8',
        '#0000FF',
        '#9900FF',
        '#FF00FF',
    ],
    [
        '#E6B8AF',
        '#F4CCCC',
        '#FCE5CD',
        '#FFF2CC',
        '#D9EAD3',
        '#D0E0E3',
        '#C9DAF8',
        '#CFE2F3',
        '#D9D2E9',
        '#EAD1DC',
    ],
    [
        '#DD7E6B',
        '#EA9999',
        '#F9CB9C',
        '#FFE599',
        '#B6D7A8',
        '#A2C4C9',
        '#A4C2F4',
        '#9FC5E8',
        '#B4A7D6',
        '#D5A6BD',
    ],
    [
        '#CC4125',
        '#E06666',
        '#F6B26B',
        '#FFD966',
        '#93C47D',
        '#76A5AF',
        '#6D9EEB',
        '#6FA8DC',
        '#8E7CC3',
        '#C27BA0',
    ],
    [
        '#A61C00',
        '#CC0000',
        '#E69138',
        '#F1C232',
        '#6AA84F',
        '#45818E',
        '#3C78D8',
        '#3D85C6',
        '#674EA7',
        '#A64D79',
    ],
    [
        '#85200C',
        '#990000',
        '#B45F06',
        '#BF9000',
        '#38761D',
        '#134F5C',
        '#1155CC',
        '#0B5394',
        '#351C75',
        '#741B47',
    ],
    [
        '#5B0F00',
        '#660000',
        '#783F04',
        '#7F6000',
        '#274E13',
        '#0C343D',
        '#1C4587',
        '#073763',
        '#20124D',
        '#4C1130',
    ],
];

function ColorPicker({ value, onChange, anchorEl, setAnchorEl, onClose }) {
    const open = Boolean(anchorEl);

    const inputRef = useRef(null);

    const savedColors =
        localStorage.getItem('donbarMailColors')?.split(',') || [];

    const handleChanged = color => {
        onChange(color);
        onClose();
        setTimeout(() => {
            const updatedSavedColors = [
                color,
                ...savedColors.filter(c => c !== color),
            ];
            localStorage.setItem(
                'donbarMailColors',
                updatedSavedColors.toString(),
            );
            if (savedColors.length > 7) {
                savedColors.pop();
                localStorage.setItem('donbarMailColors', savedColors.join(','));
            }
        }, 500);
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            onMouseDown={e => e.preventDefault()}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            // disablePortal
            disableAutoFocus
            // disableEnforceFocus
            // disableRestoreFocus
        >
            <Card sx={{ p: 1 }} elevation={1}>
                <Stack>
                    {colors.map((row, i) => (
                        <Stack key={i} direction="row">
                            {row.map((color, j) => (
                                <Checkbox
                                    key={j}
                                    sx={{
                                        p: 0,
                                        color,
                                        '&.Mui-checked': {
                                            color,
                                        },
                                    }}
                                    onMouseDown={e => e.preventDefault()}
                                    onChange={() => handleChanged(color)}
                                    icon={<CircleRounded />}
                                    checkedIcon={<CheckCircleRounded />}
                                    checked={
                                        color.replace('#', '') ===
                                        value.replace('#', '')
                                    }
                                />
                            ))}
                        </Stack>
                    ))}
                </Stack>
                <Divider sx={{ my: 1 }} />
                <Stack direction="row">
                    {savedColors.map((color, i) => (
                        <Checkbox
                            key={i}
                            sx={{
                                p: 0,
                                color,
                                '&.Mui-checked': {
                                    color,
                                },
                            }}
                            onMouseDown={e => e.preventDefault()}
                            onChange={() => handleChanged(color)}
                            icon={<CircleRounded />}
                            checkedIcon={<CheckCircleRounded />}
                            checked={
                                color.replace('#', '') ===
                                value.replace('#', '')
                            }
                        />
                    ))}
                    <IconButton
                        onClick={() => {
                            inputRef.current.click();
                        }}
                    >
                        <ColorizeRounded />
                    </IconButton>
                    <input
                        ref={inputRef}
                        type="color"
                        style={{ visibility: 'hidden', width: 0, height: 0 }}
                        onChange={e => handleChanged(e.target.value)}
                    />
                </Stack>
            </Card>
        </Popover>
    );
}

export default ColorPicker;
